module.exports = __webpack_public_path__ + "static/img/thumb-02.2cf699e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/thumb/thumb-02.png
// module id = cfX0
// module chunks = 150